import FooterMain from "./FooterMain";

export default FooterMain;
